<template>
  <el-row>
    <el-form ref="form" :model="form" size="small" label-width="120px">
      <el-row>
        <el-col>
          <el-form-item label="Centro de Custo">
            <el-cascader style="width: 100%;"
                         v-model="form.centro_custo_id"
                         change-on-select
                         filterable
                         :options="centroCustolistTree"
                         :props="{label: 'nome' , value : 'id' }">
            </el-cascader>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click.prevent="aplicar()">Aplicar</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-row>
</template>

<script>
  import {mapGetters, mapState} from 'vuex'

  export default {
    name: "MetaCentroCustoFilter",
    props: ['showfilter'],
    computed: {
      ...mapGetters(['centroCustolistTree', 'indicadorlistTree']),
      ...mapState(['anos', 'anoSelected' , 'meses' , 'mesSelected' , 'centroCustoSelected']),
    },
    data() {
      return {
        form: {
          centro_custo_id : []
        }
      }
    },
    methods: {
      aplicar() {
        this.$emit('filtroAplicado', {centro_custo_id: _.last(this.form.centro_custo_id)})
      }
    },
    mounted() {
      this.form.centro_custo_id.push(  this.centroCustoSelected)
    }
  }
</script>



// WEBPACK FOOTER //
// src/features/Competencia/MetaCentroCustoFilter.vue